import { getLocale } from "../runtime";

const sv_sicountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Slovenia`
};

const sicountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_sicountryenglish(inputs)
	return "siCountryEnglish";
};

export { sicountryenglish as "siCountryEnglish" };